export default __webpack_public_path__ + "static/media/before@3x.13b0e0c2.png";